export default __webpack_public_path__ + "static/media/centralPiece.34513467.png";